import React from "react";
import Layout from "../components/common/Layout";

const CookiesPolicy = () => {
  return (

    < Layout>
      <section className="relative min-h-screen text-white overflow-hidden">

        <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
          <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">

            <h1 className="text-3xl font-bold mb-8 text-center">COOKIE POLICY OF SLOWORK</h1>
            <p className="mb-6 text-center">Last updated: 27/02/2025</p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">1. Introduction</h2>
            <p className="mb-6">
              At Slowork (hereinafter, "the Platform"), we use cookies and similar technologies to ensure the proper functioning of our website and application, enhance user experience, and provide personalized content tailored to your interests. This Cookie Policy explains what cookies are, how we use them, and how you can manage them.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">2. What Are Cookies and Similar Technologies?</h2>
            <p className="mb-6">
              Cookies are small text files stored on your device (computer, tablet, mobile) when you visit a website. In addition to cookies, we also use similar technologies such as:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Web beacons:</strong> Small pieces of code embedded in web pages or emails to track user activity.</li>
              <li><strong>Local and session storage:</strong> Allows information to be stored in your browser to optimize site loading.</li>
              <li><strong>Tracking pixels:</strong> Used to improve advertising effectiveness.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-10 mb-4">3. Types of Cookies We Use</h2>

            <h3 className="text-xl font-semibold mt-8 mb-3">3.1. Essential (Necessary) Cookies</h3>
            <p className="mb-6">
              These cookies are fundamental for the Platform's operation and cannot be disabled in our systems. They are necessary for:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Authentication and user account access.</li>
              <li>Session security.</li>
              <li>Management of bookings and payments on the Platform.</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-3">3.2. Performance and Analytics Cookies</h3>
            <p className="mb-6">
              These allow us to analyze the use of the Platform to improve user experience. We use tools such as Google Analytics to:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Evaluate site traffic and usage.</li>
              <li>Measure the performance of different site sections.</li>
              <li>Identify technical errors and optimize navigation.</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-3">3.3. Functionality Cookies</h3>
            <p className="mb-6">
              These cookies allow the Platform to remember your preferences and customized settings, such as:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Selected language.</li>
              <li>Display preferences.</li>
              <li>Accessibility settings.</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-3">3.4. Advertising and Marketing Cookies</h3>
            <p className="mb-6">
              These cookies are used to show relevant ads based on your activity on and off the Platform. They also allow us to:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Measure the effectiveness of advertising campaigns.</li>
              <li>Personalize ads on social media and other websites.</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-3">3.5. Third-Party Cookies</h3>
            <p className="mb-6">
              Some Platform functionalities may use third-party cookies, such as:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Interactive maps (Google Maps).</li>
              <li>Social media integrations (Facebook, Instagram, LinkedIn).</li>
              <li>Payment providers (Stripe, PayPal).</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-10 mb-4">4. Duration and Storage of Cookies</h2>
            <p className="mb-6">
              Cookies can be classified into:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Session cookies:</strong> Automatically deleted when you close your browser.</li>
              <li><strong>Persistent cookies:</strong> Remain on your device for a specified period or until you delete them.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-10 mb-4">5. Managing Cookie Preferences</h2>
            <p className="mb-6">
              You can manage or delete cookies at any time from your browser settings. Below are some useful links to configure cookies in commonly used browsers:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Google Chrome</li>
              <li>Mozilla Firefox</li>
              <li>Safari</li>
              <li>Microsoft Edge</li>
            </ul>
            <p className="mb-6">
              Additionally, if you wish to opt out of receiving personalized advertising cookies, you can visit <a href="https://www.youronlinechoices.eu" className="underline">Your Online Choices</a>.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">6. Updates to the Cookie Policy</h2>
            <p className="mb-6">
              Slowork may update this Cookie Policy at any time to reflect changes in the use of cookies or applicable regulations, such as the General Data Protection Regulation (GDPR) and the Digital Services Act (DSA). Any significant changes will be communicated to users via the Platform.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">7. Contact</h2>
            <p className="mb-6">
              If you have any questions about this Cookie Policy, you can contact us at:
            </p>
            <p className="mb-6">
              📩 <strong>Email:</strong> sloworking.adm@gmail.com
            </p>

          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CookiesPolicy;
